import {createSelector} from 'reselect';
import {isLoadingLeasingCompanies} from "./leasingCompanies";
import {isLoadingDealers} from "./dealers";

export const isLoading = createSelector(isLoadingDealers, isLoadingLeasingCompanies, (...args) => args.some(Boolean));
